import type { ReactElement, ReactNode } from 'react';

import { Section } from './SectionWrap.styled';

interface SectionWrapProps {
  children: ReactNode;
}

export const SectionWrap = ({ children }: SectionWrapProps): ReactElement => (
  <Section>{children}</Section>
);
